import { State } from '@app/app.reducers';
import { createSelector } from '@ngrx/store';

export const selectFeature = (state: State) => state.genericMetaData;

export const getGenericMetadataField = (fieldName: string) => createSelector(
  selectFeature,
  state => state?.[fieldName] || []
);
